const styles = {
  Show: {
    display: 'flex',
    transition: 'all 0.3s ease-in-out !important',
  },
  Hide: {
    display: 'none',
    transition: 'all 0.3s ease-in-out !important',
  },
  SupplierUpdateForm: {
    padding: '20px 40px !important',
    margin: '0px -5vw !important',
    maxWidth: '700px !important',
  },
  CreateForm: {
    padding: '0px 40px !important',
    margin: '0px auto !important',
  },
  SupplierFormTitle: {
    padding: '32px 32px 0px 32px !important',
  },
  SelectCountry: {
    left: '460px !important',
  },
  Buttons: {
    display: 'flex !important',
    flexDirection: 'row !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    padding: '32px 32px 8px 32px !important',
  },
  FormButtons: {
    color: '#fff !important',
    backgroundColor: '#000000 !important',
    padding: '10px 123px !important',
  },
  SupplierCancelButton: {
    backgroundColor: 'rgb(255, 42, 42) !important',
    marginRight: '20px !important',
    padding: '10px 145px !important',
  },
};

export default styles;
